<template>
  <div class="">
    <div class="media skeleton tw-flex tw-flex-col tw-gap-7">
      <div class="tw-bg-true-gray-50 tw-w-[460px] tw-h-[50px]" />
      <div class="tw-p-4 tw-bg-true-gray-50 tw-h-[140px]" />
      <div class="tw-p-4 tw-bg-true-gray-50 tw-h-[140px]" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
